import { CompanyUser } from "./CompanyUser";
import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const CompanyUsers = z.object({
    companyUsers: CompanyUser.array(),
});
export type CompanyUsers = z.infer<typeof CompanyUsers>;
